import React from 'react';
import { config } from '../config/config';


const Home = () => (
    <p>{config.strings.home.header}</p>
);

export default Home;